import { render, staticRenderFns } from "./KamblyHeader.vue?vue&type=template&id=71390bfc&"
import script from "./KamblyHeader.vue?vue&type=script&lang=js&"
export * from "./KamblyHeader.vue?vue&type=script&lang=js&"
import style0 from "./KamblyHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports